"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dividerColors = exports.dividerInactive = exports.dividerPrimary = exports.iconExtraLarge = exports.iconMediumLarge = exports.iconSmallLarge = exports.iconLarge = exports.iconDefault = exports.iconSmall = void 0;

var _styledComponents = require("styled-components");

var _helperFunctions = require("../helperFunctions");

var iconSmall = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconSmall;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconSmall, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconSmall, props.theme.iconPadding);
});
exports.iconSmall = iconSmall;
var iconDefault = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconDefault;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconDefault, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconDefault, props.theme.iconPadding);
});
exports.iconDefault = iconDefault;
var iconLarge = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconLarge;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconLarge, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconLarge, props.theme.iconPadding);
});
exports.iconLarge = iconLarge;
var iconSmallLarge = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconSmallLarge;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconSmallLarge, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconSmallLarge, props.theme.iconPadding);
});
exports.iconSmallLarge = iconSmallLarge;
var iconMediumLarge = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconMediumLarge;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconMediumLarge, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconMediumLarge, props.theme.iconPadding);
});
exports.iconMediumLarge = iconMediumLarge;
var iconExtraLarge = (0, _styledComponents.css)(["font-size:", ";min-width:", ";min-height:", ";"], function (props) {
  return props.theme.iconExtraLarge;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconExtraLarge, props.theme.iconPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.iconExtraLarge, props.theme.iconPadding);
});
exports.iconExtraLarge = iconExtraLarge;
var dividerPrimary = (0, _styledComponents.css)(["background-color:", ";"], function (props) {
  return props.theme.c_clickable_cta_background;
});
exports.dividerPrimary = dividerPrimary;
var dividerInactive = (0, _styledComponents.css)(["background-color:", ";"], function (props) {
  return props.theme.tertiaryColor;
});
exports.dividerInactive = dividerInactive;
var dividerColors = {
  primary: dividerPrimary,
  inactive: dividerInactive
};
exports.dividerColors = dividerColors;